import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, vModelText as _vModelText, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "content-frame" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "row my-2" }
const _hoisted_4 = { class: "col-6" }
const _hoisted_5 = { class: "row my-2" }
const _hoisted_6 = { class: "col-6 amount-frame" }
const _hoisted_7 = { class: "amount-zeros" }
const _hoisted_8 = ["max"]
const _hoisted_9 = { class: "row justify-content-center my-3" }
const _hoisted_10 = ["disabled"]
const _hoisted_11 = { class: "content-frame" }
const _hoisted_12 = { class: "content-frame" }
const _hoisted_13 = { class: "row my-2" }
const _hoisted_14 = { class: "col text-center" }
const _hoisted_15 = { class: "row my-3 justify-content-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DialogFrame = _resolveComponent("DialogFrame")!

  return (_openBlock(), _createBlock(_component_DialogFrame, {
    "show-dialog": _ctx.show,
    "on-click-close": _ctx.close,
    title: '前払いの申込み',
    height: 200,
    width: _ctx.dialogWidth
  }, {
    dialogContent: _withCtx(() => [
      _createVNode(_Transition, { name: "fade" }, {
        default: _withCtx(() => [
          _withDirectives(_createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _cache[4] || (_cache[4] = _createElementVNode("div", { class: "col-6" }, "前払可能額", -1)),
                _createElementVNode("div", _hoisted_4, "¥" + _toDisplayString(_ctx.amountToString(_ctx.prepaymentBalance)), 1)
              ]),
              _createElementVNode("div", _hoisted_5, [
                _cache[5] || (_cache[5] = _createElementVNode("div", { class: "col-6" }, "申込み金額", -1)),
                _createElementVNode("div", _hoisted_6, [
                  _withDirectives(_createElementVNode("div", _hoisted_7, ",000", 512), [
                    [_vShow, _ctx.amountToSubmit > 0]
                  ]),
                  _withDirectives(_createElementVNode("input", {
                    class: "",
                    type: "number",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.amountToSubmit) = $event)),
                    max: Math.round(_ctx.prepaymentBalance),
                    min: "1"
                  }, null, 8, _hoisted_8), [
                    [_vModelText, _ctx.amountToSubmit]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("button", {
                  class: "col-5 btn btn-secondary mx-2",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
                }, "キャンセル"),
                _createElementVNode("button", {
                  class: "col-5 btn btn-success mx-2",
                  disabled: !_ctx.canSubmit(),
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onClickSubmit && _ctx.onClickSubmit(...args)))
                }, "申込み", 8, _hoisted_10)
              ])
            ])
          ], 512), [
            [_vShow, _ctx.dialogCondition === _ctx.submitDialogCondition.INPUTTING]
          ])
        ]),
        _: 1
      }),
      _createVNode(_Transition, { name: "fade" }, {
        default: _withCtx(() => [
          _withDirectives(_createElementVNode("div", _hoisted_11, [...(_cache[6] || (_cache[6] = [
            _createElementVNode("div", { class: "container" }, [
              _createElementVNode("div", { class: "row my-2" }, [
                _createElementVNode("div", { class: "col text-center" }, "前払い申請処理中...")
              ]),
              _createElementVNode("div", { class: "row" }, [
                _createElementVNode("div", { class: "col text-center" }, [
                  _createElementVNode("div", {
                    class: "spinner-border text-success",
                    role: "status"
                  })
                ])
              ])
            ], -1)
          ]))], 512), [
            [_vShow, _ctx.dialogCondition === _ctx.submitDialogCondition.INQUIRING]
          ])
        ]),
        _: 1
      }),
      _createVNode(_Transition, { name: "fade" }, {
        default: _withCtx(() => [
          _withDirectives(_createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.resultText), 1)
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("button", {
                class: "col-5 btn btn-success",
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.clickCloseOnResult && _ctx.clickCloseOnResult(...args)))
              }, "閉じる")
            ])
          ], 512), [
            [_vShow, _ctx.dialogCondition === _ctx.submitDialogCondition.SHOW_RESULT]
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["show-dialog", "on-click-close", "width"]))
}